import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string[];
  structuredData?: Record<string, any>;
  canonicalUrl?: string;
  image?: string;
  author?: string;
  noindex?: boolean;
  facebookAppId?: string;
  twitterUsername?: string;
}

const SEO = ({
  title,
  description,
  keywords = [],
  structuredData,
  canonicalUrl,
  image,
  author,
  noindex,
  facebookAppId= "635040739392559",
  twitterUsername="@xeloba_ge"
}: SEOProps) => {
  // დავრწმუნდეთ, რომ სურათის URL არის აბსოლუტური
  const absoluteImageUrl = image && !image.startsWith('http') 
    ? `https://xeloba.ge${image.startsWith('/') ? '' : '/'}${image}` 
    : image;
    
const cleanCanonicalUrl = canonicalUrl ? 
  canonicalUrl.split('?')[0] : // URL-დან query parameters მოშორება
  undefined;


  return (
    <Helmet>
      {/* სტანდარტული მეტა ტეგები */}
      <html lang="ka" /> {/* ენის მეტა ტეგი */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(", ")} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta charSet="utf-8" />
      {/* ავტორის ინფორმაცია */}
      <meta name="author" content={author} />
      {/* რეგიონული მეტა ტეგები */}
      <meta name="geo.region" content="GE" />
      <meta name="geo.placename" content="Georgia" />
      <meta name="geo.position" content="42.3154;43.3569" />
      <meta name="ICBM" content="42.3154, 43.3569" />
      {/* კანონიკური URL */}
      <link rel="canonical" href={cleanCanonicalUrl} />
      {/* Open Graph ტეგები */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:image:secure_url" content={absoluteImageUrl} /> 
      <meta property="og:image:width" content="1200" /> 
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} /> 
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="profile" /> 
      <meta property="og:locale" content="ka_GE" />
      <meta property="profile:first_name" content={author?.split(' ')[0] || ''} /> {/* პირველი სახელი */}
      <meta property="profile:last_name" content={author?.split(' ')[1] || ''} /> {/* გვარი */}
      {facebookAppId && <meta property="fb:app_id" content={facebookAppId} />}
      {/* Twitter Card ტეგები */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImageUrl} />
      {twitterUsername && (
        <meta name="twitter:site" content={twitterUsername} />
      )}
      {/* ძრავების ტეგები */}
      <meta
        name="googlebot"
        content={
          noindex
            ? "noindex, nofollow"
            : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        }
      />
      <meta
        name="bingbot"
        content={
          noindex
            ? "noindex, nofollow"
            : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        }
      />
      <meta
        name="yandex"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />
      {/* სტრუქტურული მონაცემები */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
      {/* სოციალური შეტყობინებები Google-სთვის */}
      <meta name="format-detection" content="telephone=no" />
    </Helmet>
  );
};

export default SEO;